const isPresent = (value) => {
  if (value === null || value === undefined) return false;
  const trimmed = String(value).trim();
  return trimmed.length > 0 && trimmed !== 'null' && trimmed !== 'undefined';
};

export const normalizeExternalUrl = (value) => {
  if (!isPresent(value)) return null;
  const url = String(value).trim();

  if (/^https?:\/\//i.test(url)) return url;
  if (/^\/\//.test(url)) return `https:${url}`;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;
  if (/^www\./i.test(url)) return `https://${url}`;

  // If the backend sends something like "t.me/foo" or "facebook.com/foo".
  return `https://${url}`;
};

export const normalizeWhatsappUrl = (value) => {
  if (!isPresent(value)) return null;
  const raw = String(value).trim();

  // Full URLs (including wa.me, api.whatsapp.com) should be used as-is (with scheme ensured).
  if (/^https?:\/\//i.test(raw)) return raw;
  if (/^\/\//.test(raw)) return `https:${raw}`;

  // If it's a phone number (optionally with +, spaces, dashes).
  const digits = raw.replace(/\D/g, '');
  if (digits.length > 0) return `https://wa.me/${digits}`;

  return normalizeExternalUrl(raw);
};
